var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFasTool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 60,
    viewBox: "0 0 64 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.5938 34.6182C51.6187 34.6182 54.125 37.1245 54.125 40.1494V47.0635C54.125 50.1748 51.6187 52.5947 48.5938 52.5947H15.4062C12.2949 52.5947 9.875 50.1748 9.875 47.0635V40.1494C9.875 37.1245 12.2949 34.6182 15.4062 34.6182H26.4688V38.7666H15.4062C14.6284 38.7666 14.0234 39.458 14.0234 40.1494V47.0635C14.0234 47.8413 14.6284 48.4463 15.4062 48.4463H48.5938C49.2852 48.4463 49.9766 47.8413 49.9766 47.0635V40.1494C49.9766 39.458 49.2852 38.7666 48.5938 38.7666H37.5312V34.6182H48.5938ZM21.6289 23.6421C20.8511 24.5063 19.5547 24.5063 18.7769 23.6421C17.9126 22.8643 17.9126 21.5679 18.7769 20.79L30.5308 9.03613C31.3086 8.17188 32.605 8.17188 33.3828 9.03613L45.1367 20.79C46.001 21.5679 46.001 22.8643 45.1367 23.6421C44.791 24.0742 44.2725 24.2471 43.7539 24.2471C43.1489 24.2471 42.6304 24.0742 42.2847 23.6421L34.0742 15.4316V38.7666C34.0742 39.9766 33.1235 40.8408 32 40.8408C30.79 40.8408 29.9258 39.9766 29.9258 38.7666V15.4316L21.6289 23.6421ZM47.2109 43.6064C47.2109 44.8164 46.2603 45.6807 45.1367 45.6807C43.9268 45.6807 43.0625 44.8164 43.0625 43.6064C43.0625 42.4829 43.9268 41.5322 45.1367 41.5322C46.2603 41.5322 47.2109 42.4829 47.2109 43.6064Z",
    fill: "#0C41C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFasTool);
export default __webpack_public_path__ + "static/media/fasTool.212d2aa7dae9b59a813f8cdb4075ef31.svg";
export { ForwardRef as ReactComponent };